<template>
  <v-container
    grid-list-lg
    pt-0
  >
    <DeliveryCondition />
    <v-layout
      row
      style="position: relative;"
    >
      <v-flex xs10>
        <MaterialCard
          color="green"
          full-width
        >
          <DeliveryTable
            :detail-id="selected ? selected.id : null"
            @select-customer="selected = $event"
          />
        </MaterialCard>
      </v-flex>

      <transition name="detail">
        <DeliveryDetail
          v-show="selected"
          :selected="selected"
          @close="selected = null"
        />
      </transition>
    </v-layout>
  </v-container>
</template>

<script>
import { DeliveryCondition, DeliveryTable, DeliveryDetail } from './components'

export default {
  components: {
    DeliveryCondition,
    DeliveryTable,
    DeliveryDetail
  },
  data () {
    return {
      selected: null
    }
  }
}
</script>

<style lang="scss" scoped>
.container.grid-list-md .layout:not(:only-child){
  margin:0px;
}
.header-config {
  position: absolute;
  left: 13px;
  top: 5px;
}

//DeliveryDetail transition
.detail-enter-active, .detail-leave-active {
  transition: transform 0.2s, opacity 0.2s ease-in-out;
}
.detail-enter, .detail-leave-to {
  transform: translateX(400px);
  opacity: 0;
}
</style>
